import * as React from "react"
import { useState, useEffect } from "react"
import * as classNames from "./SearchResultsSection.module.scss"
import Card from "../../../../common/blocks/card/Card"
import CtxHeroSection from "../../../../common/sections/ctx-hero-section/CtxHeroSection"
import ContractSearchField from "./contract-search-field/ContractSearchField"
import LocationSearchField from "./location-search-field/LocationSearchField"
import JobAdResult from "./job-ad-result/JobAdResult"
import DebouncedAxios from "../../../../../../utils/debouncedAxios"
import { site } from "../../../../../../utils/site"
import Button from "../../../blocks/button/Button"
import Icon from "../../../blocks/icon/Icon"
import { Swiper, SwiperSlide } from "swiper/react"
import RhSearchResultMobile from "./RhSearchResultMobile"
import SearchField from "./term-search-field/TermSearchField"

const RhSearchResult = ({ urlTermFilter, imageVideo }) => {
  const [termFilter, setTermFilter] = useState(urlTermFilter || "")
  const [locationFilter, setLocationFilter] = useState([])
  const [contractFilter, setContractFilter] = useState([])
  const [searchHistory, setSearchHistory] = useState([])
  const [showSearchField, setShowSearchField] = useState(false)

  const dialog = React.useRef(null)
  const locationTags = []
  const contractTags = []
  const tags = []
  for (const l of locationFilter) {
    locationTags.push(l.label)
    tags.push(l.label)
  }

  for (const c of contractFilter) {
    contractTags.push(c.label)
    tags.push(c.label)
  }
  for (const term of searchHistory) {
    tags.push(term)
  }

  const openDialog = () => {
    dialog.current.showModal()
  }

  const closeDialog = () => {
    dialog.current.close()
  }
  const handleDeleteTerm = (termToDelete) => {
    setSearchHistory((prevHistory) =>
      prevHistory.filter((term) => term !== termToDelete)
    )
  }

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 1080)
    }

    updateIsMobile()

    window.addEventListener("resize", updateIsMobile)

    // Cleanup
    return () => window.removeEventListener("resize", updateIsMobile)
  }, [])

  const showSearch = () => {
    console.log("showSearch")
    setShowSearchField(true)
  }

  const hideSearch = () => {
    setShowSearchField(false)
  }

  const handleSetTerm = (newTerm) => {
    setSearchHistory(newTerm)
    hideSearch()
  }

  return (
    <>
      {isMobile ? (
        <RhSearchResultMobile
          termFilter={termFilter}
          setTermFilter={setTermFilter}
          locationFilter={locationFilter}
          setLocationFilter={setLocationFilter}
          contractFilter={contractFilter}
          setContractFilter={setContractFilter}
          searchHistory={searchHistory}
          setSearchHistory={setSearchHistory}
          handleDeleteTerm={handleDeleteTerm}
          tags={tags}
          locationTags={locationTags}
          contractTags={contractTags}
          openDialog={openDialog}
          closeDialog={closeDialog}
          dialog={dialog}
          isMobile={isMobile}
        />
      ) : (
        <CtxHeroSection
          key="RhSearchResult"
          classes={classNames.hero}
          imgSrc={imageVideo?.image?.data?.attributes.url}
          imgAlt={imageVideo?.image?.data?.attributes.alternativeText}
          image={imageVideo?.image?.data?.attributes}
        >
          <div className="container">
            <Card
              className={`${classNames.jobSearchContainer} card_bottom flex-direction-column align-items-center justify-content-center p-6 gap-4`}
            >
              <h1 className="text-center">Découvrez nos offres d'emplois</h1>
              <div
                className={classNames.jobSearch}
                key="JobSearch"
              >
                <SearchField
                  termFilter={termFilter}
                  setTermFilter={setTermFilter}
                  setSearchHistory={handleSetTerm}
                />
                <LocationSearchField
                  locationFilter={locationFilter}
                  setLocationFilter={setLocationFilter}
                />
                <ContractSearchField
                  contractFilter={contractFilter}
                  setContractFilter={setContractFilter}
                />
              </div>

              <div
                className={`${classNames.selectedFilterContainer} text-center`}
              >
                <div className={classNames.selectedFilter}>
                  <h5 className="mb-2">Filtres sélectionnés :</h5>
                  <div className="flex">
                    <div className="tags mr-1 flex">
                      <div className={classNames.resulatButton}>
                        {tags.map((item, index) => (
                          <Button
                            key={index}
                            aspect="tag"
                            size="large"
                            color="primary"
                          >
                            <Button
                              onClick={() => {
                                setLocationFilter((old) => {
                                  return old.filter((v) => v.label !== item)
                                })

                                setContractFilter((old) => {
                                  return old.filter((v) => v.label !== item)
                                })
                                setSearchHistory((prevHistory) =>
                                  prevHistory.filter(
                                    (historyItem) => historyItem !== item
                                  )
                                )
                              }}
                            >
                              <Icon
                                icon="cross"
                                key={"icone_" + index}
                                width="15"
                                height="15"
                              />
                            </Button>
                            {item}
                          </Button>
                        ))}
                      </div>
                    </div>
                    <Button
                      aspect="unstyled"
                      className="fs-16 secondary-text-color"
                      onClick={() => {
                        setTermFilter("")
                        setLocationFilter([])
                        setContractFilter([])
                        setSearchHistory([])
                      }}
                    >
                      <Icon icon="arrowRight" />
                      Effacer tous les filtres
                    </Button>
                  </div>
                </div>
                <div className={classNames.tags}>
                  <div className={classNames.resulatButton}>
                    {tags.map((item, index) => (
                      <Button
                        key={index}
                        aspect="tag"
                        size="large"
                        color="primary"
                      >
                        <Button
                          onClick={() => {
                            setLocationFilter((old) => {
                              return old.filter((v) => v.label !== item)
                            })

                            setContractFilter((old) => {
                              return old.filter((v) => v.label !== item)
                            })
                            setSearchHistory((prevHistory) =>
                              prevHistory.filter(
                                (historyItem) => historyItem !== item
                              )
                            )
                          }}
                        >
                          <Icon
                            icon="cross"
                            key={"icone_" + index}
                            width="15"
                            height="15"
                          />
                        </Button>
                        {item}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </Card>
            <Card
              className={`${classNames.jobSearchMobile}
card_bottom flex-direction-column align-items-center justify-content-center p-6 gap-4"`}
            >
              <div
                className={classNames.jobSearchMobile}
                key="JobSearch"
              >
                <SearchField
                  termFilter={termFilter}
                  setTermFilter={setTermFilter}
                  setSearchHistory={handleSetTerm}
                />
                <Button
                  onClick={openDialog}
                  className="border-none"
                >
                  <Icon
                    icon="filter"
                    className={"filter-icon"}
                    width="36"
                    height="34"
                  />
                </Button>

                <dialog
                  ref={dialog}
                  className={classNames.dialog}
                >
                  <div className={classNames.dialogContainer}>
                    <div className={classNames.header}>
                      <p>Filtres</p>
                      <Button onClick={closeDialog}>
                        <Icon
                          icon={"cross"}
                          color={"black"}
                          className={classNames.btn}
                          autofocus
                        >
                          Close
                        </Icon>
                      </Button>
                    </div>

                    <div className={classNames.content}>
                      <p>Poste</p>

                      {showSearchField && (
                        <>
                          <SearchField
                            termFilter={termFilter}
                            setTermFilter={setTermFilter}
                            setSearchHistory={handleSetTerm}
                          />
                        </>
                      )}
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          gap: "10px",
                          paddingTop: "10px",
                        }}
                      >
                        {searchHistory.map((term, index) => (
                          <Button
                            key={index}
                            aspect="tag"
                            size="large"
                            color="primary"
                            // onClick={() => setTermFilter(term)}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleDeleteTerm(term)
                            }}
                          >
                            {term}{" "}
                            <Icon
                              icon="cross"
                              width="15"
                              height="15"
                            />
                          </Button>
                        ))}
                        <Button
                          aspect="tag"
                          size="large"
                          color="primary"
                          className={classNames.resulatButton}
                          onClick={showSearch}
                        >
                          <Icon
                            icon="plus"
                            key={"icone_plus"}
                            width="15"
                            height="15"
                          />
                        </Button>
                      </div>

                      <div className={classNames.localisation}>
                        <p>Localisation</p>
                        <LocationSearchField
                          locationFilter={locationFilter}
                          setLocationFilter={setLocationFilter}
                        />
                        <div className="tags mr-1 flex">
                          {locationTags.map((item, index) => {
                            return (
                              <Button
                                key={index}
                                aspect="tag"
                                size="large"
                                color="primary"
                                className={classNames.resulatButton}
                                onClick={() => {
                                  setLocationFilter((old) => {
                                    return old.filter((v) => v.label !== item)
                                  })
                                }}
                              >
                                <Icon
                                  icon="cross"
                                  key={"icone_" + index}
                                  width="15"
                                  height="15"
                                />
                                {item}
                              </Button>
                            )
                          })}
                        </div>
                      </div>
                      <div className={classNames.contart}>
                        <p>Contrat</p>
                        <ContractSearchField
                          contractFilter={contractFilter}
                          setContractFilter={setContractFilter}
                        />
                        <div className="tags mr-1 flex">
                          {contractTags.map((item, index) => {
                            return (
                              <Button
                                key={index}
                                aspect="tag"
                                size="large"
                                color="primary"
                                className={classNames.resulatButton}
                                onClick={() => {
                                  setContractFilter((old) => {
                                    return old.filter((v) => v.label !== item)
                                  })
                                }}
                              >
                                <Icon
                                  icon="cross"
                                  key={"icone_" + index}
                                  width="15"
                                  height="15"
                                />
                                {item}
                              </Button>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    <div className={classNames.footer}>
                      <Button
                        aspect="unstyled"
                        className="fs-16 secondary-text-color underline"
                        onClick={() => {
                          setTermFilter("")
                          setLocationFilter([])
                          setContractFilter([])
                          setSearchHistory([])
                        }}
                      >
                        Tout effacer
                      </Button>
                      <Button
                        className={classNames.btn}
                        aspect={"contrastant"}
                        color={"primary"}
                        size={"large"}
                        onClick={closeDialog}
                      >
                        Voir les résultats
                      </Button>
                    </div>
                  </div>
                </dialog>
              </div>

              <div className={classNames.tagsContainer}>
                <Swiper
                  spaceBetween={10}
                  slidesPerView={"auto"}
                  className={classNames.tagsSwiper}
                >
                  {tags.map((item, index) => (
                    <>
                      <SwiperSlide className={classNames.item}>
                        <Button
                          key={index}
                          aspect="tag"
                          size="large"
                          color="primary"
                          className={classNames.resulatButton}
                        >
                          <Button
                            onClick={() => {
                              setLocationFilter((old) => {
                                return old.filter((v) => v.label !== item)
                              })

                              setContractFilter((old) => {
                                return old.filter((v) => v.label !== item)
                              })
                              setSearchHistory((prevHistory) =>
                                prevHistory.filter(
                                  (historyItem) => historyItem !== item
                                )
                              )
                            }}
                          >
                            <Icon
                              icon="cross"
                              key={"icone_" + index}
                              width="15"
                              height="15"
                            />
                          </Button>
                          {item}
                        </Button>
                      </SwiperSlide>
                    </>
                  ))}
                </Swiper>
              </div>
            </Card>
          </div>
        </CtxHeroSection>
      )}
      <DebouncedAxios
        url={process.env.GATSBY_NEST_BASE_URL + "/search/job-ads"}
        params={{
          site,
          q: searchHistory.join(" "),
          locations: locationFilter.map((l) => l.value),
          contracts: contractFilter.map((l) => l.value),
        }}
      >
        {({ loading, error, data = [] }) => {
          // console.log("data: ", data)
          const datas = data.map((item) => {})
          return (
            <JobAdResult
              setSearchHistory={setSearchHistory}
              data={data}
              termFilter={termFilter || ""}
              setTermFilter={setTermFilter}
              locationFilter={locationFilter}
              setLocationFilter={setLocationFilter}
              contractFilter={contractFilter}
              setContractFilter={setContractFilter}
              tags={tags}
              searchHistory={searchHistory}
            />
          )
        }}
      </DebouncedAxios>
    </>
  )
}

export default RhSearchResult
